import BaseMenu from 'System/UI/Menu/BaseMenu';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { GameObjectEvent } from 'GameObject/GameObject';
import { UIActions } from 'State/UI/UIActions';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { PopupID } from 'State/UI/PopupID';
import BaseUISystem from 'System/UI/BaseUISystem';
import { PlayerCompensationPopupLayout } from 'Layouts/PlayerCompensationPopupLayout';
import Game from 'Game';
import { IPlayerCompensation } from 'State/Player/Compensation/PlayerCompensationHelper';
import TextComponent from 'Component/Render/Text';
import { RewardType } from 'Utility/Rewards/RewardType';
import { PlayerActions } from 'State/Player/PlayerActions';
import { TActionType, TransactionType } from 'Utility/Tracking/DataSet/Transaction';
import { trackResourceEvent } from 'Utility/Tracking/TrackingHelpers/Transaction';
import DateHelper from 'Utility/DateHelper';

export class PlayerCompensationPopup extends BaseMenu {
    private layout: GLayout<PlayerCompensationPopupLayout>;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.PLAYER_COMPENSATION_POPUP, uiSystem, false);
    }

    public onShow(params?: IPlayerCompensation): void {
        super.onShow();
        this.layout = getLayout(PlayerCompensationPopupLayout);
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        this.layout.headerText.getComponent(TextComponent).text = Game.locale.getText(params.title);
        this.layout.descriptionText1.getComponent(TextComponent).text = Game.locale.getText(params.description1);
        this.layout.descriptionText2.getComponent(TextComponent).text = Game.locale.getText(params.description2);

        const { rewards } = params;
        const freePlayReward = rewards.find(r => r.type === RewardType.FREE_PLAY);
        const plusFiveReward = rewards.find(r => r.type === RewardType.PLUS_FIVE_CARDS);
        const jokerReward = rewards.find(r => r.type === RewardType.JOKER);
        this.layout.freeEntryText.getComponent(TextComponent).text = `x ${freePlayReward.amount.toString()}`;
        this.layout.plusFiveText.getComponent(TextComponent).text = `x ${plusFiveReward.amount.toString()}`;
        this.layout.jokerText.getComponent(TextComponent).text = `x ${jokerReward.amount.toString()}`;

        const { closeButton, continueButton } = this.layout;
        [closeButton, continueButton].forEach(o => applyDefaultButtonAnimation(o));
        closeButton.once(GameObjectEvent.SELECTED, () => this.onCollect(params));
        continueButton.once(GameObjectEvent.SELECTED, () => this.onCollect(params));
    }

    private onCollect(params: IPlayerCompensation): void {
        const rewards = params.rewards.map(p => ({ type: p.type, value: p.amount }));
        PlayerActions.receiveRewards({
            rewards,
            queueTask: true,
            queueNext: true,
        });
        PlayerActions.setFlag({ id: 'playerCompensation', expiryDate: DateHelper.getDateFromValue(params.endDate) });
        trackResourceEvent(Game.store.getState(), { tActionType: TActionType.COMPENSATION, transactionType: TransactionType.REWARD });
        UIActions.hidePopup(this.name);
    }
}
